import { getOffZzim } from '@/common/converter/utils/get-event-property'
import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'off-zzim'
 * off zzim catalog 의 경우 테스트 필요
 * @param elementList
 * @returns {{add_timestamp: string, method: string, add_common_params: string, add_credential: string, type: string, bodyjson, url}|undefined}
 */
export const convertEventOffZzim = (elementList = []) => {
  const { type, url, method, bodyList, isRender } = getOffZzim(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
